export const isTableMode = (width) => width < 1024

export const DAY_PICKER_DESKTOP_PROPS = {
  months: 2,
  direction: 'horizontal',
}

export const DAY_PICKER_TABLET_PROPS = {
  months: 1,
}
